/*!
=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// javascipt plugin for creating charts
import Chart from "chart.js";
// node.js library that concatenates classes (strings)
import React from "react";
import {Bar, Line} from "react-chartjs-2";
// react plugin used to create charts
// reactstrap components
import {
    Button,
    Card,
    CardBody, CardText,
    CardTitle,
    Col,
    Container, DropdownItem, DropdownMenu,
    DropdownToggle,
    Progress,
    Row, Table,
    UncontrolledDropdown,
} from "reactstrap";
import {chartOptions, parseOptions,} from "../../../variables/adminCharts";

import '../../../assets/css/heroBanner.css';
import _ from "lodash";
import SubscribedUserCardsHeader from "../../../components/Headers/SubscribedUserCardsHeader";
import ReviewService from "../../../services/reviewService";
import UtilService from "../../../services/utilService";
import DownloadUtil from "../../../util/downloadUtil";
import Rating from "react-rating";
import formatFrontendDate from "../util/formatFrontendDate";
import BreakdownScoreMultiLineChart from "./BreakdownScoreMultiLineChart";
import CardFooter from "reactstrap/es/CardFooter";
import FormInput from "../../../components/common/form/FormInput";
import BreakdownScoreBarGraph from "./BreakdownScoreBarGraph";
import NotificationAlert from "react-notification-alert";

const items = [
    {
        src: 'https://picsum.photos/id/123/1200/400',
        altText: 'Slide 1',
        caption: 'Slide 1',
        key: 1,
    },
    {
        src: 'https://picsum.photos/id/456/1200/400',
        altText: 'Slide 2',
        caption: 'Slide 2',
        key: 2,
    },
    {
        src: 'https://picsum.photos/id/678/1200/400',
        altText: 'Slide 3',
        caption: 'Slide 3',
        key: 3,
    },
];


class Trends extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeNav: 1,
            chartExample1Data: "data1",
            activeIndex: 0,
            animating: false,
            score: 0,
            totalReviewsSent: 0,
            totalUnansweredReviews: 0,
            totalAnsweredReviews: 0,
            breakDownScore: {},
            breakDownChartKey: UtilService.uuidv4(),
            breakDownBarKey: UtilService.uuidv4(),
            dateFrom: null,
            dateTo: null,


        };
        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
        this.filterByContentType = this.filterByContentType.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this)
    }

    filterByContentType = (data, type) => {
        return _.filter(data, {contentType: type});
    };


    next = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({activeIndex: nextIndex})
    };

    previous = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
        this.setState({activeIndex: nextIndex})
    };

    goToIndex = (newIndex) => {
        if (this.state.animating) return;
        this.setState({activeIndex: newIndex})
    };

    componentDidMount() {
        ReviewService.userReviewDetails().then((response) => {
            this.setState({...response, breakDownBarKey : UtilService.uuidv4()});
            console.log(response);
        })
        ReviewService.historicDataForCurrentUser().then(response => {
            this.setState({historicData: response, breakDownChartKey: UtilService.uuidv4()});
        })
    }

    getColor = (score) => {
        if (score >= 4) {
            return "green";
        } else if (score > 2) {
            return "orange";
        } else if (score > 0) {
            return "red";
        } else {
            return "red"
        }
    };
    applyDateFilter = () => {
        const data = {dateFrom: this.state.dateFrom, dateTo: this.state.dateTo};
        ReviewService.historicDataForCurrentUser(data).then(response => {
            this.setState({historicData: response, breakDownChartKey: UtilService.uuidv4()});
        })
    }

    clearDateFilter = () => {
        ReviewService.historicDataForCurrentUser().then(response => {
            this.setState({historicData: response, breakDownChartKey: UtilService.uuidv4(),
                                dateFrom: null, dateTo: null});
        })
    }

    toggleShowAsTestimonial = (uniqueId, checked) => {
        ReviewService.toggleShowAsTestimonial(uniqueId).then(response => {
            const updatedRemarks = this.state.breakDownScore?.remarks.map(remark => {
                if (remark.uniqueId === uniqueId) {
                    return { ...remark, showAsTestimonial: checked };
                }
                return remark;
            });
            this.setState(prevState => ({
                breakDownScore: {
                    ...prevState.breakDownScore,
                    remarks: updatedRemarks
                }
            }));
            this.notify(
                "success",
                "SUCCESS",
                "Updated successfully!"
            );

        });
    }


    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index,
            chartExample1Data:
                this.state.chartExample1Data === "data1" ? "data2" : "data1",
        });
    };

    onChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };




    render() {
        let obj = this
        return (
            <>
                <Container className="mt-6" fluid>
                    <div className="rna-wrapper">
                        <NotificationAlert ref="notificationAlert"/>
                    </div>
                    <Row>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-primary border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Average Review Score
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {typeof this.state.score === 'number' ? this.state.score.toFixed(2) : '0.00'} / 5
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max="5"
                                                value={this.state.score || 0}
                                                color={this.getColor(this.state.score)}
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-info border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Total Invites Sent
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {this.state.totalReviewsSent || 0}/ {this.state.totalReviewsSent || 0}
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max={this.state.totalReviewsSent || 0}
                                                value={this.state.totalReviewsSent || 0}
                                                color="success"
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-gray border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Answered Invites
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {this.state.totalAnsweredReviews || 0}/{this.state.totalReviewsSent || 0}
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max={this.state.totalReviewsSent || 0}
                                                value={this.state.totalAnsweredReviews || 0}
                                                color="success"
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-danger border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Unanswered Invites
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {this.state.totalUnansweredReviews || 0}/{this.state.totalReviewsSent || 0}
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max={this.state.totalReviewsSent || 0}
                                                value={this.state.totalUnansweredReviews || 0}
                                                color="success"
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row key={UtilService.uuidv4()} className="align-items-lg-start mb-4 p-3 border rounded"
                         style={{backgroundColor: "#f8f9fe"}}>
                        {/* Column 1: Logo */}
                        <Col xs="12" md="2" className="text-center mb-3 mb-md-0">
                            <img
                                src={this.state.brandLogoUID === null ? require("assets/img/brand/companies.jpeg") :
                                    this.state.brandLogoUID && DownloadUtil.generateUrl(this.state.brandLogoUID)}
                                alt="Company Logo"
                                style={{width: "156px", height: "156px", objectFit: "contain"}}
                            />
                        </Col>

                        {/* Column 2: Company Name and Score */}
                        <Col xs="12" md="3" className="mb-3 mb-md-0">
                            <h4 className="font-weight-bold"><b>{this.state.companyName}</b></h4>
                            <p>Average Score: {this.state.score?.toFixed(1) ?? "0.0"}/5</p>
                            <Rating
                                readonly
                                initialRating={this.state.score}
                                emptySymbol={<i className="fa fa-star text-muted"/>}
                                fullSymbol={<i className="fa fa-star text-warning"/>}
                                fractions={2}
                                title={this.state.score?.toFixed(1)}
                            />
                            <p>Total Reviews - ({this.state.breakDownScore?.totalReviews || 0})</p>
                        </Col>

                        {/* Column 3: Review Count and Breakdown */}
                        <Col xs="12" md="6">
                            {/*<p><b><strong>Breakdown:</strong></b> {item.scoreBreakdown?.breakdown?.length ?? 0}</p>*/}

                            {this.state.breakDownScore?.breakdown?.length > 0 ? (
                                <Row>
                                    {this.state.breakDownScore.breakdown.map((entry, index) => (
                                        <Col key={index} xs="12" sm="12" className="mb-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{fontSize: "0.9rem"}}>{entry.question}:</span>
                                                <span style={{whiteSpace: "nowrap", marginLeft: "0.5rem"}}>
                                                <Rating
                                                    readonly
                                                    initialRating={entry.breakdownScore}
                                                    emptySymbol={<i className="fa fa-star text-muted"/>}
                                                    fullSymbol={<i className="fa fa-star text-warning"/>}
                                                    fractions={2}
                                                    title={entry.breakdownScore.toFixed(1)}
                                                />
                                                <span className="ml-2">{entry.breakdownScore.toFixed(1)}/5</span>
                                            </span>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <p className="text-muted mt-2">No breakdown available</p>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <Card className="shadow">
                                <CardBody>
                                    <CardTitle tag="h4">Trends</CardTitle>
                                    <CardFooter>
                                        <Row>
                                            <Col xs="12" md="4" className="text-center"><FormInput
                                                name="dateFrom"
                                                className="form-control-label"
                                                id="date"
                                                placeholder="inputPlaceHolder.meetingReport.date"
                                                type="date"
                                                onChange={this.onChange}
                                                value={this.state.dateFrom || ""}
                                                label="Date From"
                                            />
                                            </Col>
                                            <Col xs="12" md="4" className="text-center">
                                                <FormInput
                                                    name="dateTo"
                                                    className="form-control-label"
                                                    id="date"
                                                    placeholder="inputPlaceHolder.meetingReport.date"
                                                    type="date"
                                                    onChange={this.onChange}
                                                    value={this.state.dateTo || ""}
                                                    label="Date To"
                                                />
                                            </Col>
                                            <Col xs="12" md="4" className="text-center" style={{marginTop: "32px"}}>
                                                <Button size="md" outline color="default" type="button"
                                                        onClick={this.applyDateFilter}
                                                >
                                                    Apply Filter
                                                </Button>
                                                <Button color="default" size="md" outline type="button"
                                                        onClick={this.clearDateFilter}>
                                                    Clear Filter
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                    {Array.isArray(this.state.historicData) && (
                                        <BreakdownScoreMultiLineChart
                                            data={this.state.historicData}
                                            key={this.state.breakDownChartKey}
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                    <Row>
                        <Col xs="12" md="12">
                            <Card className="shadow">
                                <CardBody>
                                    <CardTitle tag="h4">Scores</CardTitle>
                                    {Array.isArray(this.state.breakDownScore?.breakdown) && (
                                        <BreakdownScoreBarGraph
                                            data={this.state.breakDownScore?.breakdown}
                                            key={this.state.breakDownBarKey}
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                    {<Row>
                        {this.state.breakDownScore?.remarks?.length > 0 ? (
                            <Col xs="12" md="12">
                                <Card className="shadow">
                                    <CardBody>
                                        <CardTitle tag="h4">Remarks/Testimonials</CardTitle>
                                        <CardText>
                                            <Table className="align-items-center table-flush" responsive>
                                                <thead className="thead-light">
                                                <tr>
                                                    <th className="sort" data-sort="name" scope="col">
                                                        #
                                                    </th>
                                                    <th className="sort" data-sort="budget" scope="col">
                                                        Date
                                                    </th>
                                                    <th className="sort" data-sort="status" scope="col">
                                                        Reviewer
                                                    </th>
                                                    <th className="sort" data-sort="status" scope="col">
                                                        Approved for Public
                                                    </th>
                                                    <th className="sort" data-sort="status" scope="col">
                                                        Remark
                                                    </th>
                                                    <th className="sort" data-sort="status" scope="col">
                                                        Tetsimonial
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody className="list">
                                                {this.state.breakDownScore?.remarks.map(function (value, index) {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="budget">{index + 1}</td>
                                                            <td className="budget">{formatFrontendDate(value?.date)}</td>
                                                            <td className="budget">{value?.contact?.firstName} {value?.contact?.lastName}</td>
                                                            <td className="budget">{value?.remarkPublic ? "YES" : "NO"}</td>
                                                            <td className="budget" style={{
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word"
                                                            }}>{value?.remark}</td>
                                                            <td className="budget">
                                                                {value?.remarkPublic && <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',       // vertical centering
                                                                        justifyContent: 'center',  // horizontal centering
                                                                        // paddingTop: "10px",
                                                                        height: '100%'              // ensure full height of td
                                                                    }}
                                                                >
                                                                    <FormInput
                                                                        name="reviewsSearchEnabled"
                                                                        className="form-control-label"
                                                                        id="reviewsSearchEnabled"
                                                                        placeholder="Testimonial remark"
                                                                        type="checkbox"
                                                                        onChange={(e) => {
                                                                            obj.toggleShowAsTestimonial(value?.uniqueId, e.target.checked)
                                                                        }}
                                                                        label=""
                                                                        checked={value?.showAsTestimonial}
                                                                        errorMsg={""}
                                                                        style={{
                                                                            // marginRight: '8px', top: "132px"
                                                                        }}
                                                                    />

                                                                </div>}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </Table>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>
                        ) : (
                            <Col xs="12" md="12">
                                <Card className="shadow">
                                    <CardBody>
                                        <CardTitle tag="h4">Remarks/Testimonials</CardTitle>
                                        <CardText>
                                            <h3>No Data available to show!</h3>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>)
                        }

                    </Row>}
                </Container>
            </>
        );
    }
}

export default Trends;
